module.exports = __webpack_public_path__ + "static/reward-modal-icon.dc10c892.png";